<div *ngIf="displayNotification" class="notification-container" [ngClass]="notificationObject.position === 'top' ? 'notification-top ' : 'notification-bottom' ">
    <div class=" p-1-25 min-width-46 flex-display" [ngClass]="(notificationObject.type === 'success') ? 'notification-success' : 'notification-error'" >
        <div class="inline-icon-padding">
            <mat-icon *ngIf="notificationObject.type === 'success'">done</mat-icon>
            <mat-icon *ngIf="notificationObject.type === 'error'">error_outline</mat-icon>
        </div>
        <div class="m-auto-0" tabindex="0">
            {{notificationObject.message}}
        </div>
    </div>
</div>
